import axiosConfig from "./axiosConfig";
import { LeadCandidate } from "./postLeadSearch";

export interface VoaPremiumEnrichRequest {
  sourceRefs: string[];
}

export interface VoaPremiumEnrichResponse {
  candidates: LeadCandidate[];
}

// Run the paid Google Places passes (Places Text Search + Places Nearby)
// against one or more VOA rows. Default search is now cheap-path only;
// this is the operator-opt-in upgrade for rows where the cheap path
// missed the brand tenant or pinned the building loosely.
const postVoaPremiumEnrich = async (
  authToken: string,
  body: VoaPremiumEnrichRequest
): Promise<VoaPremiumEnrichResponse> => {
  const { data } = await axiosConfig.post(`/leads/voa-premium-enrich`, body, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default postVoaPremiumEnrich;
